import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import store from './store-redux/store';
import { API_BASE_URL, APP_PREFIX_PATH } from 'configs/AppConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));




root.render(
  <Provider store={store}>
    <Router>
    
      <App />
    </Router>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
